/**
* Scrolling Steps JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Steps component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-steps',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.scrolling-steps' ).each( function( index, element ) {
        const mm = gsap.matchMedia();
        mm.add( '(min-width: 1024px)', () => {
          // pin the component
          const navHeight = $( '.navbar' ).outerHeight();
          const introHeight = window.innerHeight / 4;
          const steps = $( element ).find( '.scrolling-steps__step' );
          const stepsLength = $( element ).find( '.scrolling-steps__step' ).length;
          $( ':root' ).css( {'--listoffsetHeight': `${introHeight}px`} );
          $( steps ).each( function( index, step ) {
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: step,
                pin: step,
                pinSpacing: index === ( stepsLength - 1 ) ? true : false,
                endTrigger: index === ( stepsLength - 1 ) ? element : step,
                start: `top ${navHeight + introHeight}px`,
                scrub: true,
                toggleActions: 'play none reverse none',
              },
            },
            );

            const stepImage = $( step ).find( '.step__image' );
            const stepContent = $( step ).find( '.step__content' );

            if ( index > 0 ) {
              tl.from( stepImage, {
                opacity: 0,
                duration: 0.5,
              }, 0 );

              tl.from( stepContent, {
                opacity: 0,
                duration: 0.1,
              }, 0 );
            }

            if ( index !== ( stepsLength -1 ) ) {
              tl.to( stepImage, {
                opacity: 0,
                duration: 0.5,
              }, 1 );

              tl.to( stepContent, {
                opacity: 0,
                duration: 0.2,
              }, 1 );
            }
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-steps', COMPONENT );
} )( app );
